import { useController } from '@framework/form/hooks/useController.ts';
import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact.ts';
import { RuleType } from '../../IRule.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';
import { TextFormat } from './TextFormat.rule.ts';

const FIELD_NAME = `rules.${RuleType.TextFormat}`;

export function TextFormatRuleComponent() {
  const formatFieldName = `${FIELD_NAME}.format`;
  const formatCustomFieldName = `${FIELD_NAME}.customFormat`;
  const formatCustomValidationMessage = `${FIELD_NAME}.customMessage`;

  const { field: formatField } = useController(formatFieldName);

  return (
    <>
      <FormItem name={formatFieldName} label="Formato">
        <$SpaceCompact block size="large">
          <SelectInput
            name={formatFieldName}
            allowClear
            onClear={() => {
              formatField.onChange(null);
            }}
            options={[
              {
                label: 'Email',
                value: TextFormat.Email,
              },
              {
                label: 'Numero',
                value: TextFormat.Number,
              },
              {
                label: 'Partita IVA',
                value: TextFormat.Piva,
              },
              {
                label: 'Codice Fiscale',
                value: TextFormat.FiscalCode,
              },
              {
                label: 'Telefono',
                value: TextFormat.Phone,
              },
              {
                label: 'Personalizzato (espressione regolare)',
                value: TextFormat.Custom,
              },
            ]}
          />
          <CustomValidationRuleMessage name={formatCustomValidationMessage} />
        </$SpaceCompact>
      </FormItem>
      <FormItem
        name={formatCustomFieldName}
        label="Formato personalizzato"
        help={
          'Inserire un’espressione regolare per validare il testo inserito dall’utente.'
        }
      >
        <TextInput name={formatCustomFieldName} />
      </FormItem>
    </>
  );
}
